import React, { useState, useEffect } from 'react';
import './Profile.css';
import { useUser } from '../App';
import { FaUserCircle, FaShareAlt } from 'react-icons/fa'; // Добавили иконку "Поделиться"

function Profile() {
  const user = useUser();
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- Формируем реферальную ссылку в одном месте ---
  const referralLink = user && user.referral_code 
    ? `https://t.me/zhagavpn_bot/webapp?startapp=ref_${user.referral_code}`
    : '';

  useEffect(() => {
    if (!user) return;

    const tg = window.Telegram?.WebApp;
    if (!tg || !tg.initData) return;

    const fetchKeys = async () => {
      try {
        const response = await fetch('/api/my-keys', {
            headers: { 'init-data': tg.initData }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setKeys(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchKeys();
  }, [user]);

  const copyToClipboard = (text, message = 'Скопировано!') => {
    // Современный асинхронный API для буфера обмена
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
            .then(() => alert(message))
            .catch(err => {
                console.warn('Ошибка копирования через Clipboard API, пробую старый метод: ', err);
                fallbackCopyTextToClipboard(text, message);
            });
    } else {
        // Запасной вариант для старых браузеров или небезопасного контекста (http)
        console.warn('Clipboard API не доступен, используется старый метод.');
        fallbackCopyTextToClipboard(text, message);
    }
  };

  // Запасной метод копирования через document.execCommand
  const fallbackCopyTextToClipboard = (text, message) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Стили, чтобы элемент не был виден
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.width = "2em";
    textArea.style.height = "2em";
    textArea.style.padding = "0";
    textArea.style.border = "none";
    textArea.style.outline = "none";
    textArea.style.boxShadow = "none";
    textArea.style.background = "transparent";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            alert(message);
        } else {
            alert('Не удалось скопировать.');
        }
    } catch (err) {
        console.error('Ошибка при использовании execCommand: ', err);
        alert('Не удалось скопировать.');
    }

    document.body.removeChild(textArea);
  };

  const shareReferralLink = () => {
    const tg = window.Telegram?.WebApp;
    if (referralLink && tg) {
      const text = `Привет! 👋 Присоединяйся и получай качественный VPN. Используй мою ссылку и получи 50 бонусных рублей на свой счет после первой покупки!\n\n${referralLink}`;
      tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent(text)}`);
    }
  };

  if (!user) {
    return <div className="profile-container">Загрузка данных пользователя...</div>;
  }

  return (
    <div className="profile-container page-container" style={{paddingTop: '80px'}}>
      
      <div className="profile-header">
        {user.photo_url ? (
          <img src={user.photo_url} alt="User" className="profile-photo"/>
        ) : (
          <FaUserCircle className="profile-photo-placeholder" />
        )}
        <div className="profile-info">
          <h1 className="profile-name">{user.first_name} {user.last_name}</h1>
          <p className="profile-username">@{user.username} (ID: {user.telegram_id})</p>
        </div>
      </div>

      {/* <div className="profile-section">
        <h2>Статус подписки</h2>
        {user.has_active_subscription ? (
          <p className="status-active">Активна до: {new Date(user.subscription_end_date).toLocaleDateString()}</p>
        ) : (
          <p className="status-inactive">Нет активной подписки</p>
        )}
      </div> */}

      <div className="profile-section">
        <h2>Мои ключи</h2>
        {loading ? <p>Загрузка ключей...</p> : 
         error ? <p className="error-message">Ошибка: {error}</p> :
         keys.length > 0 ? (
          <div className="keys-list">
            {keys.map((key) => (
              <div key={key.id} className="key-card">
                <pre className="key-data">{key.key_data}</pre>
                <div className="key-details">
                  <span>Действителен до: {new Date(key.expiration_date).toLocaleDateString()}</span>
                  <button onClick={() => copyToClipboard(key.key_data, 'Ключ скопирован!')} className="copy-button">
                    Копировать
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>У вас пока нет активных ключей.</p>
        )}
      </div>

    </div>
  );
}

export default Profile; 
